var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#FBFBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 24.75H14.5001C13.0235 24.75 11.8751 23.6016 11.8751 22.125V20.1562C11.8751 19.8008 12.1485 19.5 12.5313 19.5C12.8868 19.5 13.1876 19.8008 13.1876 20.1562V22.125C13.1876 22.8633 13.7618 23.4375 14.5001 23.4375H21.5001C22.211 23.4375 22.8126 22.8633 22.8126 22.125V20.1562C22.8126 19.8008 23.086 19.5 23.4688 19.5C23.8243 19.5 24.1251 19.8008 24.1251 20.1562V22.125C24.1251 23.5742 22.9493 24.75 21.5001 24.75ZM18.4376 20.2109L22.1563 16.7109C22.4297 16.4648 22.4297 16.0547 22.1837 15.7812C21.9376 15.5078 21.5274 15.5078 21.254 15.7539L18.6563 18.2148V11.4062C18.6563 11.0508 18.3555 10.75 18.0001 10.75C17.6172 10.75 17.3438 11.0508 17.3438 11.4062V18.2148L14.7188 15.7539C14.4454 15.5078 14.0352 15.5078 13.7891 15.7812C13.6797 15.918 13.6251 16.082 13.6251 16.2188C13.6251 16.4102 13.6797 16.5742 13.8165 16.7109L17.5352 20.2109C17.7813 20.457 18.1915 20.457 18.4376 20.2109Z",
    fill: "#5C3CE4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#9D8AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta);
export default __webpack_public_path__ + "static/media/CTA.4275e62b79703c1429068247a84b7ccb.svg";
export { ForwardRef as ReactComponent };